const ListEmailSchedules = () => import('@/domain/emailSchedules/ListEmailSchedules.vue')
const NewEmailSchedule = () => import('@/domain/emailSchedules/NewEmailSchedule.vue')
const EditEmailSchedule = () => import('@/domain/emailSchedules/EditEmailSchedule.vue')

export default [
  {
    path: 'email-schedules',
    redirect: 'email-schedules/list',
    name: 'event.emailSchedules',
    component: {
      render(c) {
        return c('router-view')
      }
    },
    meta: {
      label: 'Email Schedules',
      breadcrumb: {
        to: { name: 'event.emailSchedules.list' },
        text: 'Email Schedules'
      }
    },
    children: [
      {
        path: 'list',
        name: 'event.emailSchedules.list',
        component: ListEmailSchedules,
        meta: {
          scopeType: 'pica-service',
          permission: 'email_scheduler.list',
          label: 'Email Schedules'
        }
      },
      {
        path: 'new',
        name: 'event.emailSchedules.new',
        component: NewEmailSchedule,
        meta: {
          scopeType: 'pica-service',
          permission: 'email_scheduler.create',
          label: 'Create Email Schedule',
          breadcrumb: { text: 'Create New' }
        }
      },
      {
        path: ':scheduleId',
        name: 'event.emailSchedules.edit',
        component: EditEmailSchedule,
        meta: {
          scopeType: 'pica-service',
          permission: 'email_scheduler.edit',
          label: 'Edit Email Schedule',
          breadcrumb: (context) => {
            const schedule = context.store.getters['emailSchedules/schedule']
            return {
              text: schedule ? schedule.job_type : 'Edit'
            }
          }
        }
      }
    ]
  }
]
